var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlay2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1352px",
    height: "679px",
    viewBox: "0 0 1352 679",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "overlay1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.2031837%",
    y1: "64.9149328%",
    x2: "79.3919483%",
    y2: "29.4087923%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCAD3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91ACF3",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing-bg",
    transform: "translate(0, -516)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg",
    transform: "translate(-592.3881, -20)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "overlay1",
    points: "1354.199 536.092505 1943.96868 536.092505 772.927648 1763 183.15797 1763"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay2);
export default __webpack_public_path__ + "static/media/overlay2.a17c9a3eeb2f593b0abe2af72204fdde.svg";
export { ForwardRef as ReactComponent };